import React from 'react'

const HowAreYouTodaySkeleton = () => {
  return (
    <div
      className="rounded-xl flex-1 flex flex-col items-center justify-between min-h-[185px] animate-pulse"
      style={{ background: 'linear-gradient(152.02deg, #716EBF 16.55%, #5259A4 81.86%), #413F5E' }}
    >
      {/* Header section */}
      <div className="how-do-you-feel-container w-full px-[35px] pt-5">
        <div className="flex flex-col justify-center gap-1">
          <div className="h-5 bg-white opacity-50 rounded w-[40%] mb-1"></div>
          <div className="h-4 bg-[#BEBECE] opacity-50 rounded w-[80%]"></div>
        </div>
      </div>

      {/* Emotions scrollable area */}
      <div className="w-full justify-start items-center relative h-[115px]">
        <div className="absolute top-[7px] left-0 right-0 m-[0_auto] w-[90%] flex items-start justify-center">
          {/* Left arrow button */}
          <div
            className="mt-4 w-[50px] flex items-center justify-center h-[50px] rounded-full min-w-[50px] border-[5px] border-[#6364B3] opacity-70"
            style={{ background: 'linear-gradient(180deg, #7172BA 0%, #7D7EC2 100%)' }}
          >
            <div className="w-[15px] h-[15px] bg-white opacity-50 rounded"></div>
          </div>

          {/* Emotions icons placeholders */}
          <div className="px-4 h-24 flex gap-6 flex-nowrap mx-3">
            {[...Array(4)].map((_, index) => (
              <div key={index} className="flex flex-col items-center min-w-[50px]">
                <div className="w-[50px] h-[50px] rounded-full bg-white opacity-30 mt-4"></div>
                <div className="h-4 bg-[#BEBECE] opacity-30 rounded w-[50px] mt-2"></div>
              </div>
            ))}
          </div>

          {/* Right arrow button */}
          <div
            className="mt-4 w-[50px] flex items-center justify-center h-[50px] rounded-full min-w-[50px] border-[5px] border-[#555BA7] opacity-70"
            style={{ background: 'radial-gradient(82% 82% at 50% 9%, #646AAE 0%, #6F75B7 100%)' }}
          >
            <div className="w-[15px] h-[15px] bg-white opacity-50 rounded"></div>
          </div>
        </div>

        <div className="h-[50px]"></div>
        <div
          className="w-full rounded-xl flex justify-center h-[70%]"
          style={{
            background: 'linear-gradient(180deg, rgba(255, 255, 255, 0.09) 0%, rgba(255, 255, 255, 0) 100%)',
          }}
        ></div>
      </div>
    </div>
  )
}

export default HowAreYouTodaySkeleton